import { Component, inject, Input } from '@angular/core';
import { BasicForm } from '@shared/components/classes/basic.form';
import { DefaultService } from '@common/references/default.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputValidatorDirective } from '@common/directive/input-validator.directive';
import { PasswordModule } from '@primeng/password';
import { InputNumberModule } from '@primeng/inputnumber';
import { CalendarModule } from '@primeng/calendar';
import { DropdownModule } from '@primeng/dropdown';
import { MultiSelectModule } from '@primeng/multiselect';
import { CheckboxModule } from '@primeng/checkbox';
import { RadioButtonModule } from '@primeng/radiobutton';
import { SliderModule } from '@primeng/slider';
import { InputSwitchModule } from '@primeng/inputswitch';
import { InputTextareaModule } from '@primeng/inputtextarea';
import { ColorPickerModule } from '@primeng/colorpicker';
import { ChipsModule } from '@primeng/chips';
import { InputMaskModule } from '@primeng/inputmask';
import { FloatLabelModule } from '@primeng/floatlabel';
import { CitiesService } from "@modules/settings/cities/cities.service";
import { ToggleButtonModule } from "@primeng/togglebutton";
import {TranslatePipe} from "@ngx-translate/core";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { UtilityProvidersService } from '@modules/settings/utility-providers/utility-providers.service';
import { AutocompleteComponent } from '@shared/components/autocomplete/autocomplete.component';
import { UtilityProviderTypesService } from '@modules/settings/utility-types/utility-provider-types.service';

@Component({
  selector: 'app-tariff-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputValidatorDirective,
    PasswordModule,
    InputNumberModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    CheckboxModule,
    RadioButtonModule,
    SliderModule,
    InputSwitchModule,
    InputTextareaModule,
    ColorPickerModule,
    ChipsModule,
    InputMaskModule,
    FloatLabelModule,
    ToggleButtonModule,
    TranslatePipe,
    NgSelectComponent,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    AutocompleteComponent,
  ],
  templateUrl: './tariff-form.component.html',
  styleUrl: './tariff-form.component.scss',
})
export class TariffFormComponent extends BasicForm<any> {
  @Input() selectedRow: any = {};


  _defaultService: DefaultService<any> = inject(CitiesService);
  utilityProviderTypesService = inject(UtilityProviderTypesService);
  utilityProvidersService = inject(UtilityProvidersService);

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    super();
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(200)]],
      utilityProviderId: [null, [Validators.required]],
      utilityProviderTypeId: [null, [Validators.required]],
      price: [null, [Validators.required]],
      status: [true],
    });
  }
}
